/*
  Какие файлы накопителя - «свои» для шага домовой книги (21.10.2026).

  Раньше шаг получал ВСЕ присланные файлы и сам оставлял нужные: открытые сканы (читаются,
  ждут сверки, не прочитались) и те, что прислал или открыл на сверку сам. Список файлов с
  21.10.2026 режет сервер, и отбирать по одной странице нельзя: скан ушёл бы на вторую
  страницу вместе с «открытостью». Поэтому оба отбора делает сервер - `open_scans` и `ids`.
  Здесь - два запроса и слияние: свежие первыми, файл, попавший в оба отбора, один раз.

  Перечитывается, когда меняется `stamp` (опрос вкладки сообщил об изменении или человек
  что-то сделал) или состав названных файлов.
*/

import { useEffect, useState } from 'react'

import { api } from '../../api/client.js'

// Больше пятисот номеров в одном запросе сервер не берёт; шаг помнит присланное им.
const MAX_NAMED = 500

const newestFirst = (a, b) => b.uploaded_at.localeCompare(a.uploaded_at) || a.id.localeCompare(b.id)

export function mergeOwn(answers) {
  const byId = new Map()
  answers.forEach((answer) => answer.items.forEach((file) => byId.set(file.id, file)))
  return [...byId.values()].sort(newestFirst)
}

export default function useOwnScans(stamp, ownIds) {
  const [state, setState] = useState({ files: [], error: null })
  const named = ownIds.slice(-MAX_NAMED).join(',')

  useEffect(() => {
    // `stamp` пуст (`null`), пока опрос вкладки не ответил: читать сейчас значило бы
    // прочитать дважды - до первого ответа опроса и после него.
    if (stamp === null) return undefined
    // Ответ запоздавшего запроса, который уже не нужен, не затирает свежий.
    let alive = true
    const asks = [api.uploads({ open_scans: true, limit: 500 })]
    if (named) asks.push(api.uploads({ ids: named, limit: 500 }))
    Promise.all(asks)
      .then((answers) => {
        if (alive) setState({ files: mergeOwn(answers), error: null })
      })
      .catch((error) => {
        if (alive) setState((was) => ({ ...was, error }))
      })
    return () => {
      alive = false
    }
  }, [stamp, named])

  return state
}
